export enum NAVIGATION_KEYS {
    home = '',
    results = 'results',
    detail = 'detail'
}